import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.81226 8.15625C2.81226 5.20498 5.20473 2.8125 8.15601 2.8125C11.1073 2.8125 13.4998 5.20498 13.4998 8.15625C13.4998 11.1075 11.1073 13.5 8.15601 13.5C5.20473 13.5 2.81226 11.1075 2.81226 8.15625ZM8.15601 1.6875C4.58341 1.6875 1.68726 4.58366 1.68726 8.15625C1.68726 11.7288 4.58341 14.625 8.15601 14.625C9.73966 14.625 11.1904 14.0559 12.3149 13.1111L15.3516 16.1478C15.5713 16.3675 15.9274 16.3675 16.1471 16.1478C16.3668 15.9281 16.3668 15.572 16.1471 15.3523L13.1104 12.3156C14.0555 11.1911 14.6248 9.74015 14.6248 8.15625C14.6248 4.58366 11.7286 1.6875 8.15601 1.6875Z",
  fill: "#839AAF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }